import { Injectable } from "@angular/core";
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";

import { Observable } from "rxjs";

import { AuthorizationService } from "../services/authorization.service";

@Injectable()
export class DefaultRouteGuard  {

    constructor(
        private _router: Router,
        private authorizationService: AuthorizationService,
    ) { }


    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        this._router.navigate([this.authorizationService.getDefaultRoute(state.url)]);
        return false;
    }
}